<template>
  <v-menu v-if="user" offset-x :close-on-content-click="false" :nudge-width="200">
    <template v-slot:activator="{ on }">
      <v-btn icon v-on="on">
        <v-avatar size="32">
          <img
            v-if="user && user.image"
            :src="user.image.contentUrl + '?x-request=html'"
            :alt="`${user.firstName} ${user.lastName}`"
          />
          <img v-else src="../assets/no-img.svg" />
        </v-avatar>
      </v-btn>
    </template>

    <v-card>
      <v-list>
        <v-list-item>
          <v-list-item-avatar>
            <img
              v-if="user && user.image"
              :src="user.image.contentUrl + '?x-request=html'"
              :alt="`${user.firstName} ${user.lastName}`"
            />
            <img v-else src="../assets/no-img.svg" />
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>{{ user.firstName }} {{ user.lastName }}</v-list-item-title>
            <v-list-item-subtitle>{{ user.email }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="$router.push({ name: 'logout' })">Logout</v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters('user', ['list']),

    user() {
      return this.list[0]
    }
  }
}
</script>
